import { NextPage } from 'next';
import { getDataFromTree } from '@apollo/client/react/ssr';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
// Hocks
import withApollo from 'hocs/withApollo';
// Helpers
import { getEnvLink } from 'helpers/routes';
// Context
import { FiltersProvider } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Types
import { MemorabiliaOrderBy, SortDirection } from 'api/graphql-global-types';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Footer from 'layouts/Footer/Footer';
// Components
import AllMemorabiliaContainer from 'components/AllMemorabilia/AllMemorabilia';
import PageBanner from 'components/common3/PageBanner/PageBanner';

const TITLE = 'Memorabilia';

const AllProducts: NextPage = () => {
  const image = `${getEnvLink()}${'/products.jpg'}`;
  const bannerImage = `${getEnvLink()}${'/images/page-banner-images/shop.png'}`;

  const router = useRouter();

  // Memorabilia and Products no longer have separate nav entries/filtering —
  // drop a stale ?productType= from bookmarked/indexed links so the URL
  // matches what's actually shown (everything, unfiltered by type).
  useEffect(() => {
    if (!router.query.productType) {
      return;
    }

    const restQuery = { ...router.query };
    delete restQuery.productType;

    router.replace({ pathname: router.pathname, query: restQuery }, undefined, {
      shallow: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.productType]);

  return (
    <>
      <Head
        image={image}
        title="Athlete Exclusive Memorabilia & Products on MILLIONS.co"
        description="Shop your favorite athletes, gyms, and sports creators memorabilia and custom products, exclusively on MILLIONS. Check out the limited edition items, one of a kind autographed memorabilia, latest drops, newest releases, and trending products. Available globally!"
      />
      <Header />
      <PageBanner title={TITLE} imageUrl={bannerImage} />

      <FiltersProvider
        storesListFilter="hasActiveProducts"
        searchKey="searchTerm"
        hideProductType
        initialSorting={{
          direction: SortDirection.DESC,
          order: MemorabiliaOrderBy.createdAt,
        }}
      >
        <AllMemorabiliaContainer title={TITLE} />
      </FiltersProvider>
      <Footer />
    </>
  );
};

export default withApollo(AllProducts, { getDataFromTree });
